<div class="dialog-container">
    <h2 mat-dialog-title>Artikel verwalten</h2>
    <mat-dialog-content>
        <mat-form-field
            appearance="outline"
            class="deliveryNoteSelect">
            <mat-label>Lieferschein auswählen</mat-label>
            <mat-select
                [(ngModel)]="selectedDeliveryNote"
                (ngModelChange)="loadArticles()">
                @for (note of deliveryNotes(); track note._key) {
                    <mat-option [value]="note">{{ note.fileName }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <button
            type="button"
            mat-stroked-button
            [disabled]="!selectedDeliveryNote()"
            (click)="toggleCreateArticleForm()">
            Artikel hinzufügen
        </button>
        <div class="articlesTableWrapper">
            <table
                mat-table
                [dataSource]="articles"
                class="articles-table">
                <ng-container matColumnDef="articleNumber">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Artikelnummer
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.articleNumber }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Beschreibung
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.description }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="quantity">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Menge
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.quantity }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="index">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Index
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.index }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="articleOrderNumber">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        PO
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.articleOrderNumber || '-' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="customerArticleNumber">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Kundenartikel-Nr.
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        {{ e.customerArticleNumber || '-' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Löschen
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let e">
                        <button
                            type="button"
                            mat-icon-button
                            (click)="onDeleteArticle(e)">
                            <mat-icon fontSet="material-symbols-outlined"
                                >delete</mat-icon
                            >
                        </button>
                    </td>
                </ng-container>
                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button
            mat-stroked-button
            (click)="closeDialog()">
            Schließen
        </button>
    </mat-dialog-actions>
</div>
